import { render, staticRenderFns } from "./BackgroundImg.vue?vue&type=template&id=45427e7d&scoped=true&"
import script from "./BackgroundImg.vue?vue&type=script&lang=js&"
export * from "./BackgroundImg.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundImg.vue?vue&type=style&index=0&id=45427e7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45427e7d",
  null
  
)

export default component.exports